export default __webpack_public_path__ + "static/media/LaLista.7b6fbec7.jpg";